// removed by extract-text-webpack-plugin
module.exports = {"ContactPage":"ContactPage__-loca-__1kqV_","Prompt":"ContactPage__-loca-__3oPRr","SpaceBetween":"ContactPage__-loca-__2hXCb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/ContactPage/ContactPage.css
// module id = 247
// module chunks = 0